import { Link } from "react-router-dom";

export default function BillingCancelPage() {
  return (
    <div className="text-center py-16 animate-rise" data-testid="billing-cancel-page">
      <p className="font-heading font-bold text-2xl">Checkout canceled</p>
      <p className="text-ink/60 mt-2">No charge was made. You can start your trial whenever you're ready.</p>
      <Link to="/pricing" className="inline-block mt-6 h-11 px-5 rounded-lg bg-tea hover:bg-tea-hover text-tea-text text-sm font-medium leading-[2.75rem] transition-colors duration-200">
        Back to plans
      </Link>
    </div>
  );
}
